











import { Component } from 'vue-property-decorator';
import BaseSelect from '@/modules/core/components/BaseSelect.vue';
import { agencyApi } from '../agency.api';
import { Agency } from '../agency';

@Component
export default class AgencySelect extends BaseSelect<Agency> {
  public async getOptions(): Promise<Agency[]> {
    try {
      const result = await agencyApi.findAll({});
      this.options = result;
      return this.options;
    } catch (_) {
      return [];
    }
  }
}
